export function setNotifications(state, payload) {
    state.notifications = payload
}
export function updateNotifications(state, payload) {

    state.notifications.current_page = payload.current_page
    state.notifications.data = state.notifications.data.concat(payload.data)
    state.notifications.first_page_url = payload.first_page_url
    state.notifications.from = payload.from
    state.notifications.last_page = payload.last_page
    state.notifications.last_page_url = payload.last_page_url
    state.notifications.next_page_url = payload.next_page_url
    state.notifications.path = payload.path
    state.notifications.per_page = payload.per_page
    state.notifications.prev_page_url = payload.prev_page_url
    state.notifications.to = payload.to
    state.notifications.total = payload.total

}
export function resetStore(state) {
    state.notifications = [];
}